import Joi from '@hapi/joi'

export const passwordSchemaObject = {
    userName: Joi.string().required().label("User Name").messages({ "string.empty": `User Name Required`, }),
    oldPassword: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `Password Required`,
    }),
    newPassword: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `New Password Required`,
    }),
    confirmPassword: Joi.string().required().label("Password").regex(/^(?=.{5,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `Confirm Password Required`,
    }),
}